import React, { Component } from "react";
import InformeComponent from "../components/InformeComponent";
import Landing from "./../../landing/containers/LandingContainer";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import CopyGraphIcon from "@material-ui/icons/ReplyAll";
import DownloadIcon from "@material-ui/icons/GetApp";
import CopyIcon from "@material-ui/icons/FileCopy";
import DeleteIcon from "@material-ui/icons/Delete";
import LeftAlign from "@material-ui/icons/FormatAlignLeft";
import CenterAlign from "@material-ui/icons/FormatAlignCenter";
import RightAlign from "@material-ui/icons/FormatAlignRight";
import JustifyAlign from "@material-ui/icons/FormatAlignJustify";
import DownIcon from "@material-ui/icons/ArrowDropDown";
import CityIcon from "@material-ui/icons/LocationCity";

import Turbo from "./../../images/cities/2020/turbo.png";
import AlcaldiaEslogan from "./../../images/logo-escudo.png";
import Escudo from "./../../images/escudo_t.png";

// import Apartado from "./../../images/cities/2020/apartado.png";
// import Arboletes from "./../../images/cities/2020/arboletes.png";
// import Carepa from "./../../images/cities/2020/carepa.png";
// import Chigorodo from "./../../images/cities/2020/chigorodo.png";
// import Murindo from "./../../images/cities/2020/murindo.png";
// import Mutata from "./../../images/cities/2020/mutata.png";
// import Necocli from "./../../images/cities/2020/necocli.png";
// import SanJuandeUraba from "./../../images/cities/2020/san-juan.png";
// import SanPedro from "./../../images/cities/2020/san-pedro.png";
// import Turbo from "./../../images/cities/2020/turbo.png";

import html2canvas from "html2canvas";

import OpenFileModal from "../components/OpenFileModalComponent";
import SaveAsFileModal from "../components/SaveAsFileModalComponent";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "./../../Actions/Dashboard";
import * as modalActs from "./../../Actions/Modal";
import * as sessionActs from "./../../Actions/Session";

import { CREATE_INFORM } from "./../../constants/strings/StringsDashboard";

import interact from "interactjs";

import { sendService, answerOk } from "./../../Services/service";

import "./../shop.css";

/* global jsPDF */

const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = window.atob(b64Data);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};
const contentType = "image/png";

class InformeContainer extends Component {
  state = {
    anchorEl: null,
    typeContext: "img",
    userList: [],
    userValue: 0,
    userText: "",
    fileValue: -1,
    fileText: "",
    fileName: "",
    users: null,
    files: null,
    fileList: [],
    openFile: -1,
    fileSaved: 1
  };

  dragMoveListener = event => {
    var target = event.target,
      // keep the dragged position in the data-x/data-y attributes
      x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx,
      y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;
    // translate the element
    target.style.webkitTransform = target.style.transform =
      "translate(" + x + "px, " + y + "px)";
    target.setAttribute("data-x", x);
    target.setAttribute("data-y", y);
  };

  componentDidMount = () => {
    interact(".resize-drag")
      .draggable({
        // enable inertial throwing
        inertia: true,
        // keep the element within the area of it's parent
        restrict: {
          restriction: "parent",
          endOnly: true,
          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
        },
        // enable autoScroll
        autoScroll: true,
        // call this function on every dragmove event
        onmove: this.dragMoveListener,
        // call this function on every dragend event
        onend: event => {
          this.setState({ fileSaved: 0 });
          this.props.actions.moveElement(
            Number(event.target.id.split("-")[1]),
            Number(event.target.getAttribute("data-x")),
            Number(event.target.getAttribute("data-y"))
          );
        }
      })
      .resizable({
        // resize from all edges and corners
        edges: { left: false, right: true, bottom: true, top: false },
        // keep the edges inside the parent
        restrictEdges: {
          outer: "parent",
          endOnly: true
        },
        // minimum size
        restrictSize: {
          min: { width: 100, height: 50 }
        },
        inertia: true,
        onend: event => {
          this.setState({ fileSaved: 0 });
          this.props.actions.resizeElement(
            Number(event.target.id.split("-")[1]),
            event.target.width,
            event.target.height
          );
        }
      })
      .on("resizemove", function (event) {
        var target = event.target,
          x = parseFloat(target.getAttribute("data-x")) || 0,
          y = parseFloat(target.getAttribute("data-y")) || 0;
        // update the element's style
        target.style.width = event.rect.width + "px";
        target.style.height = event.rect.height + "px";

        // translate when resizing from top or left edges
        x += event.deltaRect.left;
        y += event.deltaRect.top;

        target.style.webkitTransform = target.style.transform =
          "translate(" + x + "px," + y + "px)";

        target.setAttribute("data-x", x);
        target.setAttribute("data-y", y);
      });
    interact(".drag")
      .draggable({
        // enable inertial throwing
        inertia: true,
        // keep the element within the area of it's parent
        ignoreFrom: ".rectangulo",
        restrict: {
          restriction: ".work-sheet",
          endOnly: true,
          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
        },
        // enable autoScroll
        autoScroll: true,
        // call this function on every dragmove event
        onmove: this.dragMoveListener,
        // call this function on every dragend event
        onend: event => {
          this.setState({ fileSaved: 0 });
          this.props.actions.moveElement(
            Number(event.target.childNodes[0].id.split("-")[1]),
            Number(event.target.getAttribute("data-x")),
            Number(event.target.getAttribute("data-y"))
          );
        }
      })
      .resizable({
        // resize from all edges and corners
        edges: { left: false, right: true, bottom: true, top: false },
        // keep the edges inside the parent
        restrictEdges: {
          outer: "parent",
          endOnly: true
        },
        // minimum size
        restrictSize: {
          min: { width: 100, height: 50 }
        },
        inertia: true,
        onend: event => {
          this.setState({ fileSaved: 0 });
          this.props.actions.resizeElement(
            Number(event.target.childNodes[0].id.split("-")[1]),
            event.target.width,
            event.target.height
          );
        }
      })
      .on("resizemove", function (event) {
        var target = event.target,
          x = parseFloat(target.getAttribute("data-x")) || 0,
          y = parseFloat(target.getAttribute("data-y")) || 0;
        target.style.width = event.rect.width + "px";
        target.style.height = event.rect.height + "px";

        x += event.deltaRect.left;
        y += event.deltaRect.top;

        target.style.webkitTransform = target.style.transform =
          "translate(" + x + "px," + y + "px)";

        target.setAttribute("data-x", x);
        target.setAttribute("data-y", y);
      });
    window.dragMoveListener = this.dragMoveListener;
  };

  preventDefault = event => {
    event.preventDefault();
  };

  handleContext = (event, type) => {
    this.preventDefault(event);
    this.setState({ typeContext: type });
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handlerDrop = event => {
    this.preventDefault(event);
    var data = event.dataTransfer.getData("text");
    if (data.split("-")[0] === "shield") {
      var c = document.createElement("canvas");
      var img = document.getElementById(data);
      c.height = img.naturalHeight;
      c.width = img.naturalWidth;
      var ctx = c.getContext("2d");
      ctx.drawImage(img, 0, 0, c.width, c.height);
      var base64String = c.toDataURL();
      this.setState({ fileSaved: 0 });
      this.props.actions.accumulateShields(
        base64String,
        "shield",
        c.width,
        c.height
      );
    } else {
      this.setState({ fileSaved: 0 });
      this.props.actions.selectGraphics(Number(data.split("-")[1]));
    }
  };

  handlerDropStack = event => {
    this.preventDefault(event);
    var data = event.dataTransfer.getData("text");
    this.setState({ fileSaved: 0 });
    this.props.actions.backGraphics(Number(data.split("-")[1]));
  };

  getElementFromContextMenu = element => {
    let type = element.nodeName;
    if (type === "DIV") {
      if (element.classList.contains("images-item")) {
        return element.childNodes[0];
      }
    } else if (type === "IMG") {
      return element;
    }
    return element;
  };

  getUsersList = async body => {
    var res = await sendService("/api/v1/fileInforme/getList", "GET", body);
    return res;
  };

  getFilesList = async (saveAs = false) => {
    var res = await sendService("/api/v1/fileInforme/getList?saveAs=" + saveAs, "GET");
    if (!answerOk(res, this.props.sessionActions.closeSession)) return
    return res.response;
  };

  handlerDownloadImage = element => {
    this.handleClose();
    let type = this.getElementFromContextMenu(element);
    let base = type.src.split(",")[1];
    const blob = b64toBlob(base, contentType);
    window.saveAs(blob, "Download.png");
  };

  handlerCreateCopy = element => {
    this.handleClose();
    let type = this.getElementFromContextMenu(element);
    this.setState({ fileSaved: 0 });
    this.props.actions.createCopy(Number(type.id.split("-")[1]));
  };

  handlerCopyclipboard = () => {
    this.handleClose();
    var text = document.getElementsByClassName("text-active")[0].innerText;
    navigator.clipboard.writeText(text);
    // this.props.actions.createCopy(Number(type.id.split('-')[1]));
  };

  handlerPasteclipboard = () => {
    this.handleClose();
    navigator.clipboard
      .readText()
      .then(text => this.pasteText(text))
      .catch(err => {
        console.error("Failed to read clipboard contents: ", err);
      });
  };

  handlerDownloadPdf = () => {
    html2canvas(document.getElementById("work-sheet"), {
      useCORS: true
    }).then(canvas => {
      var imgData = canvas.toDataURL("image/jpeg", 1.0);
      var pdf = new jsPDF("p", "px", [1000, 1415]);
      pdf.addImage(imgData, "JPEG", 0, 0, 1000, 1415);
      pdf.save("informe.pdf");
    });
    return;
  };

  handlerSaveFile = async () => {
    console.log('s', this.state)
    if (!this.state.fileSaved) {
      if (this.state.openFile > -1) {
        console.log('1', this.state)
        await this.onSaveFile(this.state.openFile)
      } else {
        console.log('2', this.state)
        await this.handlerSaveAs()
      }
    }
  };

  handlerOpenFile = async () => {
    if (this.state.fileValue < 1) {
      alert('Seleccione un archivo')
      return
    }
    var url = "/api/v1/fileInforme/getDoc/" + this.state.fileValue
    var res = await sendService(url, "GET")
    console.log(res)
    if (!answerOk(res, this.props.sessionActions.closeSession)) return
    let file = JSON.parse(res.response.content)
    this.setState({ fileSaved: 1, openFile: (res.response.userId === this.props.session.user.id) ? res.response.id : 0, fileName: res.response.name })
    this.props.actions.openFile(file.graphicsStP, file.graphicsWS)
    this.handlerCloseModal()
  };

  handlerSaveAsFile = () => {
    if (this.state.fileValue > -1) {
      let conf = window.confirm("El archivo ya existe, ¿desea reemplazarlo?")
      if (!conf) return
    }
    if (this.state.fileText === "") {
      alert("Ingrese un nombre de archivo.")
      return;
    }
    this.onSaveFile(this.state.fileValue)
  };
  onSaveFile = async (fileId) => {
    var url = "/api/v1/fileInforme/saveDoc"
    this.props.modalActions.openLoader()
    let save = {
      graphicsStP: this.props.graphicsStP,
      graphicsWS: this.props.graphicsWS
    }
    let body = {
      content: JSON.stringify(save),
      name: this.state.fileText,
      id: (fileId > -1) ? fileId : 0
    }
    console.log(body)
    var res = await sendService(url, "POST", body)
    console.log('r', res)
    if (!answerOk(res, this.props.sessionActions.closeSession)) return
    this.setState({ openFile: (res.response.userId === this.props.session.user.id) ? res.response.id : 0, fileSaved: 1, fileName: res.response.name })
    this.props.modalActions.closeLoader()
    this.handlerCloseModal()
  }

  handlerCloseModal = () => {
    this.setState({ fileValue: -1, fileText: "", userValue: this.props.session.user.id });
    this.props.modalActions.closeModal();
  };

  handlerChangeTextModal = modal => event => {
    let select = this.state.fileValue;
    const preDocs = this.state.userList.filter(l => l.userId === this.state.userValue)
    for (let i = 0; i < preDocs[0].documents.length; i++) {
      if (preDocs[0].documents[i].name === event.target.value) {
        select = preDocs[0].documents[i].id;
        break;
      } else {
        select = -1;
      }
    }
    this.setState({ fileText: event.target.value, fileValue: select });
    if (modal === "open") {
      this.props.modalActions.openModal(
        <OpenFileModal
          userList={this.state.userList}
          userValue={this.state.userValue}
          userText={this.state.userText}
          fileValue={select}
          fileText={event.target.value}
          onSelectUser={this.handlerSelectUser}
          onCancel={this.handlerCloseModal}
          onOpen={this.handlerOpenFile}
          onClickFile={this.handlerClickFile}
          onBoubleClickFile={this.handlerDoubleClickFile}
          onSelectFile={this.handlerClickFile}
          onChangeText={this.handlerChangeTextModal}
        />
      );
    } else {
      console.log('1')
      this.props.modalActions.openModal(
        <SaveAsFileModal
          userList={this.state.userList}
          userValue={this.state.userValue}
          userText={this.state.userText}
          fileValue={select}
          fileText={event.target.value}
          onSelectUser={this.handlerSelectUser}
          onCancel={this.handlerCloseModal}
          onSave={this.handlerSaveAsFile}
          onClickFile={this.handlerClickFile}
          onBoubleClickFile={this.handlerDoubleClickFile}
          onSelectFile={this.handlerClickFile}
          onChangeText={this.handlerChangeTextModal}
        />
      );
    }
  };

  handlerClickFile = (event, modal) => {
    this.setState({
      fileValue: event.target.value,
      fileText: event.target.name
    });
    if (modal === "open") {
      this.props.modalActions.openModal(
        <OpenFileModal
          userList={this.state.userList}
          userValue={this.state.userValue}
          userText={this.state.userText}
          fileValue={event.target.value}
          fileText={event.target.name}
          fileList={this.state.files}
          onSelectUser={this.handlerSelectUser}
          onCancel={this.handlerCloseModal}
          onOpen={this.handlerOpenFile}
          onClickFile={this.handlerClickFile}
          onBoubleClickFile={this.handlerDoubleClickFile}
          onSelectFile={this.handlerClickFile}
          onChangeText={this.handlerChangeTextModal}
        />
      );
    } else {
      console.log('2')
      this.props.modalActions.openModal(
        <SaveAsFileModal
          userList={this.state.userList}
          userValue={this.state.userValue}
          userText={this.state.userText}
          fileValue={event.target.value}
          fileText={event.target.name}
          fileList={this.state.files}
          onSelectUser={this.handlerSelectUser}
          onCancel={this.handlerCloseModal}
          onSave={this.handlerSaveAsFile}
          onClickFile={this.handlerClickFile}
          onBoubleClickFile={this.handlerDoubleClickFile}
          onSelectFile={this.handlerClickFile}
          onChangeText={this.handlerChangeTextModal}
        />
      );
    }
  };

  handlerDoubleClickFile = (event, modal) => {
    this.handlerClickFile(event, modal);
    if (modal === "open") {
      this.handlerOpenFile();
    } else {
      this.handlerSaveAsFile();
    }
  };

  handlerSelectUser = (event, modal) => {
    if (event.target.value === this.state.userValue) return;
    this.setState({
      userValue: event.target.value,
      fileValue: -1,
      fileText: ""
    });
    if (modal === "open") {
      this.props.modalActions.openModal(
        <OpenFileModal
          userList={this.state.userList}
          userValue={event.target.value}
          userText={this.state.userText}
          fileValue={this.state.fileValue}
          fileText={this.state.fileText}
          fileList={this.state.files}
          onSelectUser={this.handlerSelectUser}
          onCancel={this.handlerCloseModal}
          onOpen={this.handlerOpenFile}
          onClickFile={this.handlerClickFile}
          onBoubleClickFile={this.handlerDoubleClickFile}
          onSelectFile={this.handlerClickFile}
          onChangeText={this.handlerChangeTextModal}
        />
      );
    } else {
      console.log('3')
      this.props.modalActions.openModal(
        <SaveAsFileModal
          userList={this.state.userList}
          userValue={event.target.value}
          userText={this.state.userText}
          fileValue={this.state.fileValue}
          fileText={this.state.fileText}
          fileList={this.state.files}
          onSelectUser={this.handlerSelectUser}
          onCancel={this.handlerCloseModal}
          onSave={this.handlerSaveAsFile}
          onClickFile={this.handlerClickFile}
          onBoubleClickFile={this.handlerDoubleClickFile}
          onSelectFile={this.handlerClickFile}
          onChangeText={this.handlerChangeTextModal}
        />
      );
    }
  };

  handlerOpen = async () => {
    if (!this.state.fileSaved) {
      let res = window.confirm(
        "No ha guardado los cambios del documento actual, al abrir un archivo perderá los cambios realizados, ¿Desea abrir un archivo?"
      );
      if (!res) return;
    }
    let files = await this.getUsersAndFiles();
    console.log('files', files)
    this.setState({
      userList: files,
      userValue: this.props.session.user.id
    })
    this.props.modalActions.openModal(
      <OpenFileModal
        userList={this.state.userList}
        userValue={this.props.session.user.id}
        fileValue={this.state.fileValue}
        fileText={this.state.fileText}
        onSelectUser={this.handlerSelectUser}
        onCancel={this.handlerCloseModal}
        onOpen={this.handlerOpenFile}
        onClickFile={this.handlerClickFile}
        onBoubleClickFile={this.handlerDoubleClickFile}
        onSelectFile={this.handlerClickFile}
        onChangeText={this.handlerChangeTextModal}
      />
    );
  };

  handlerSaveAs = async () => {
    let files = await this.getUsersAndFiles(true);
    console.log(files)
    console.log(files)
    this.setState({
      userList: files,
      userValue: this.props.session.user.id
    })
    console.log('4')
    this.props.modalActions.openModal(
      <SaveAsFileModal
        userList={this.state.userList}
        userValue={this.props.session.user.id}
        fileValue={this.state.fileValue}
        fileText={this.state.fileText}
        onSelectUser={this.handlerSelectUser}
        onCancel={this.handlerCloseModal}
        onSave={this.handlerSaveAsFile}
        onClickFile={this.handlerClickFile}
        onBoubleClickFile={this.handlerDoubleClickFile}
        onSelectFile={this.handlerClickFile}
        onChangeText={this.handlerChangeTextModal}
      />
    );
  };

  getUsersAndFiles = async (saveAs) => {
    this.props.modalActions.openLoader();
    let files = await this.getFilesList(saveAs);
    this.props.modalActions.closeLoader();
    return files;
  };

  // getUsersList = files => {
  //   var users = [];
  //   for (let i = 0; i < files.content.length; i++) {
  //     if (i === 0) {
  //       users.push({ value: i, text: files.content[i].userName });
  //       continue;
  //     }
  //     let is = false;
  //     for (let j = 0; j < users.length; j++) {
  //       if (files.content[i].userName === users[j].text) {
  //         is = true;
  //         break;
  //       }
  //     }
  //     if (!is) {
  //       users.push({ value: i, text: files.content[i].userName });
  //     }
  //   }
  //   return users;
  // };

  handlerNew = () => {
    if (!this.state.fileSaved) {
      let res = window.confirm(
        "No ha guardado los cambios del documento actual, al abrir un archivo nuevo perderá los cambios realizados, ¿Desea abrir un archivo?"
      );
      if (!res) return;
    }
    this.setState({
      userList: [],
      userValue: 1,
      userText: "",
      fileValue: -1,
      fileText: "",
      users: null,
      files: null,
      fileList: [],
      openFile: -1,
      fileSaved: 1,
      fileName: ''
    });
    this.props.actions.deleteData();
  };

  handlerDeleteElement = element => {
    this.handleClose();
    let type = this.getElementFromContextMenu(element);
    this.setState({ fileSaved: 0 });
    this.props.actions.deleteInformElement(Number(type.id.split("-")[1]));
  };

  handlerPasteText = event => {
    this.preventAndStop(event);
    let clipboardData = event.clipboardData || window.clipboardData;
    let pastedData = clipboardData.getData("Text");
    this.pasteText(pastedData);
  };

  pasteText = pastedData => {
    pastedData = pastedData.replace(/[^\x20-\xFF]/gi, "");
    const selection = window.getSelection();
    if (!selection.rangeCount) return false;
    selection.getRangeAt(0).insertNode(document.createTextNode(pastedData));
  };

  handlerClickText = event => {
    if (!event.target.classList.contains("text-active")) {
      event.target.classList.add("text-active");
    }
    this.preventAndStop(event);
  };

  handlerDbclickText = event => {
    this.preventAndStop(event);
  };

  handlerLongDown = event => {
    this.preventAndStop(event);
  };

  handlerLongUp = event => {
    this.preventAndStop(event);
  };

  preventAndStop = event => {
    event.preventDefault();
    event.stopPropagation();
  };

  handrlerDobleClickWS = () => {
    this.setState({ fileSaved: 0 });
    this.props.actions.accumulateTexts();
  };

  handlerChangeText = event => {
    this.setState({ fileSaved: 0 });
    this.props.actions.editText(
      Number(event.target.id.split("-")[1]),
      event.target.innerText
    );
  };

  handlerTextformatChange = (type, addClass) => {
    try {
      var textBox = document.getElementsByClassName("text-active")[0];
      if (type === "text") {
        textBox.classList.remove("title-calibri-16");
        textBox.classList.remove("subtitle-calibri-14");
        textBox.classList.remove("subtitle-calibri-14");
        textBox.classList.remove("budy-calibri-12");
        textBox.classList.remove("source-calibri-10");
        textBox.classList.remove("bold");
        textBox.classList.remove("italic");
      } else if (type === "align") {
        textBox.classList.remove("align-left");
        textBox.classList.remove("align-center");
        textBox.classList.remove("align-right");
        textBox.classList.remove("align-justify");
      }
      var classes = addClass.split(" ");
      for (let i = 0; i < classes.length; i++) {
        textBox.classList.add(classes[i]);
      }
      let classes1 = textBox.classList.value.replace("rectangulo ", "");
      this.setState({ fileSaved: 0 });
      this.props.actions.editClassText(
        Number(textBox.id.split("-")[1]),
        classes1
      );
    } catch (e) {
      alert("Seleccione un cuadro de texto");
      return;
    }
  };

  handlerEnter = event => {
    event.target.classList.add("grag-over");
  };

  handlerOut = event => {
    event.target.classList.remove("grag-over");
  };

  getDownloadContextItem = () => {
    if (
      this.state.typeContext === "img" ||
      this.state.typeContext === "shield"
    ) {
      return (
        <MenuItem
          onClick={() => this.handlerDownloadImage(this.state.anchorEl)}
          onContextMenu={e => e.preventDefault()}
        >
          <ListItemIcon>
            <DownloadIcon />
          </ListItemIcon>
          <ListItemText inset primary={CREATE_INFORM.DOWNLOAD} />
        </MenuItem>
      );
    }
  };

  getCreateCopyContextItem = () => {
    if (this.state.typeContext === "img") {
      return (
        <MenuItem
          onClick={() => this.handlerCreateCopy(this.state.anchorEl)}
          onContextMenu={e => e.preventDefault()}
        >
          <ListItemIcon>
            <CopyGraphIcon />
          </ListItemIcon>
          <ListItemText inset primary={CREATE_INFORM.CREATE_COPY} />
        </MenuItem>
      );
    }
  };

  getDeleteContextItem = () => {
    return (
      <MenuItem
        onClick={() => this.handlerDeleteElement(this.state.anchorEl)}
        onContextMenu={e => e.preventDefault()}
      >
        <ListItemIcon>
          <DeleteIcon />
        </ListItemIcon>
        <ListItemText inset primary={CREATE_INFORM.DELETE} />
      </MenuItem>
    );
  };

  getCopyClipboardContextItem = () => {
    if (this.state.typeContext === "text") {
      return (
        <MenuItem
          onClick={() => this.handlerCopyclipboard(this.state.anchorEl)}
          onContextMenu={e => e.preventDefault()}
          className="no-click"
        >
          <ListItemIcon className="no-click">
            <CopyIcon className="no-click" />
          </ListItemIcon>
          <ListItemText
            inset
            primary={CREATE_INFORM.COPY_CLIPBOARD}
            className="no-click"
          />
        </MenuItem>
      );
    }
  };

  getPasteClipboardContextItem = () => {
    if (this.state.typeContext === "text") {
      return (
        <MenuItem
          onClick={() => this.handlerPasteclipboard(this.state.anchorEl)}
          onContextMenu={e => e.preventDefault()}
        >
          <ListItemIcon>
            <DeleteIcon />
          </ListItemIcon>
          <ListItemText inset primary={CREATE_INFORM.PASTE_CLIPBOARD} />
        </MenuItem>
      );
    }
  };

  handlerDrag = event => {
    let type = event.target.nodeName;
    if (type === "DIV") {
      event.dataTransfer.setData("text", event.target.childNodes[0].id);
    } else {
      event.dataTransfer.setData("text", event.target.id);
    }
  };

  render() {
    const open = Boolean(this.state.anchorEl);
    const now = new Date();
    return (
      <Landing history={this.props.history} hasFooter={false}>
        <>
          <InformeComponent
            acumulatedGraphics={this.props.graphicsStP}
            workGraphics={this.props.graphicsWS}
            onGraphicContext={this.handleContext}
            preventDefault={this.preventDefault}
            handlerEnter={this.handlerEnter}
            handlerOut={this.handlerOut}
            handlerDragOver={this.handlerDragOver}
            handlerDrop={this.handlerDrop}
            handlerDropStack={this.handlerDropStack}
            handlerDragStart={this.handlerDrag}
            handrlerDobleClickWS={this.handrlerDobleClickWS}
            handlerPasteText={this.handlerPasteText}
            handlerClickText={this.handlerClickText}
            handlerDbclickText={this.handlerDbclickText}
            handlerChangeText={this.handlerChangeText}
            onTouchStart={this.handlerLognDown}
            onTouchEnd={this.handlerLognUp}
            onNew={this.handlerNew}
            onOpen={this.handlerOpen}
            onSave={this.handlerSaveFile}
            onSaveAs={this.handlerSaveAs}
            onPdf={this.handlerDownloadPdf}
            fileText={this.state.fileName}
            menus={[
              {
                id: "menu1",
                text: (
                  <>
                    {CREATE_INFORM.TEXTS} <DownIcon className="no-click" />
                  </>
                ),
                dropbtn: "inform-dropbtn",
                dropdownContent: "inform-dropdown-content",
                dropdown: "inform-dropdown",
                items: [
                  {
                    text: CREATE_INFORM.TITLE_CALIBRI_16,
                    func: () =>
                      this.handlerTextformatChange("text", "title-calibri-16"),
                    classNames: "submenu title-calibri-16"
                  },
                  {
                    text: CREATE_INFORM.SUBTITLE_CALIBRI_14,
                    func: () =>
                      this.handlerTextformatChange(
                        "text",
                        "subtitle-calibri-14"
                      ),
                    classNames: "submenu subtitle-calibri-14"
                  },
                  {
                    text: CREATE_INFORM.TEXT_BUDY_CALIBRI_12,
                    func: () =>
                      this.handlerTextformatChange("text", "budy-calibri-12"),
                    classNames: "submenu budy-calibri-12"
                  },
                  {
                    text: CREATE_INFORM.TEXT_BUDY_CALIBRI_12,
                    func: () =>
                      this.handlerTextformatChange(
                        "text",
                        "budy-calibri-12 italic"
                      ),
                    classNames: "submenu budy-calibri-12 italic"
                  },
                  {
                    text: CREATE_INFORM.TEXT_BUDY_CALIBRI_12,
                    func: () =>
                      this.handlerTextformatChange(
                        "text",
                        "budy-calibri-12 bold"
                      ),
                    classNames: "submenu budy-calibri-12 bold"
                  },
                  {
                    text: CREATE_INFORM.TEXT_BUDY_CALIBRI_12,
                    func: () =>
                      this.handlerTextformatChange(
                        "text",
                        "budy-calibri-12 italic bold"
                      ),
                    classNames: "submenu budy-calibri-12 italic bold"
                  },
                  {
                    text: CREATE_INFORM.SOURCE_CALIBRI_10,
                    func: () =>
                      this.handlerTextformatChange("text", "source-calibri-10"),
                    classNames: "submenu source-calibri-10"
                  }
                ]
              },
              {
                id: "menu2",
                text: (
                  <>
                    <LeftAlign className="no-click" />{" "}
                    <DownIcon className="no-click" />
                  </>
                ),
                dropbtn: "inform-dropbtn",
                dropdownContent: "inform-dropdown-content",
                dropdown: "inform-dropdown",
                items: [
                  {
                    text: <LeftAlign />,
                    func: () =>
                      this.handlerTextformatChange("align", "align-left"),
                    classNames: "submenu menu-item-icon"
                  },
                  {
                    text: <CenterAlign />,
                    func: () =>
                      this.handlerTextformatChange("align", "align-center"),
                    classNames: "submenu menu-item-icon"
                  },
                  {
                    text: <RightAlign />,
                    func: () =>
                      this.handlerTextformatChange("align", "align-right"),
                    classNames: "submenu menu-item-icon"
                  },
                  {
                    text: <JustifyAlign />,
                    func: () =>
                      this.handlerTextformatChange("align", "align-justify"),
                    classNames: "submenu menu-item-icon"
                  }
                ]
              },
              {
                id: "menu3",
                text: (
                  <>
                    <CityIcon className="no-click" />{" "}
                    <DownIcon className="no-click" />
                  </>
                ),
                dropbtn: "inform-dropbtn",
                dropdownContent: "inform-dropdown-content cities-content",
                dropdown: "inform-dropdown",
                items: [
                  {
                    text: (
                      <div
                        className="no-click"
                        draggable
                        onDragOver={ev => ev.preventDefault()}
                        onDragStart={this.handlerDrag}
                      >
                        <img
                          src={Escudo}
                          alt="escudo"
                          id={"shield-" + now.getTime() + 2}
                        ></img>
                      </div>
                    ),
                    func: this.handlerItem2Menu2,
                    classNames: "submenu mpio-menu-item"
                  },
                  {
                    text: (
                      <div
                        className="no-click"
                        draggable
                        onDragOver={ev => ev.preventDefault()}
                        onDragStart={this.handlerDrag}
                      >
                        <img
                          src={Turbo}
                          alt="Turbo"
                          id={"shield-" + now.getTime()}
                        ></img>
                      </div>
                    ),
                    func: this.handlerItem2Menu2,
                    classNames: "submenu mpio-menu-item"
                  },
                  {
                    text: (
                      <div
                        className="no-click"
                        draggable
                        onDragOver={ev => ev.preventDefault()}
                        onDragStart={this.handlerDrag}
                      >
                        <img
                          src={AlcaldiaEslogan}
                          alt="EsloganAlcaldía"
                          id={"shield-" + now.getTime() + 1}
                        ></img>
                      </div>
                    ),
                    func: this.handlerItem2Menu2,
                    classNames: "submenu mpio-menu-item"
                  },
                ]
              }
            ]}
          />
          <Menu
            anchorEl={this.state.anchorEl}
            open={open}
            onClose={this.handleClose}
            PaperProps={{
              style: {
                maxHeight: 300,
                minHeight: 80, //MAX_HEIGHT DE 48 * 4.5
                // maxWidth: 190,
                minWidth: 200
              }
            }}
          >
            <MenuList className="client-menu-options">
              {this.getDownloadContextItem()}
              {this.getCreateCopyContextItem()}
              {this.getCopyClipboardContextItem()}
              {/* {this.getPasteClipboardContextItem()} */}
              {this.getDeleteContextItem()}
            </MenuList>
          </Menu>
        </>
      </Landing>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    graphicsStP: state.dashboard.graphicsAcucumulated,
    graphicsWS: state.dashboard.graphicsWorkSpace,
    session: state.session
  };
}

function mapDispatchToProps(dispatch) {
  return {
    modalActions: bindActionCreators(modalActs, dispatch),
    actions: bindActionCreators(actions, dispatch),
    sessionActions: bindActionCreators(sessionActs, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InformeContainer);
